<template>
  <div>
    <template>
      <v-btn
        v-if="user.role === 'superviseur'"
        dark
        block
        color="red"
        class="rounded-pill mb-4"
        @click.stop="groupeDialog = true"
      >
        <v-icon class="mr-4">mdi-account-plus</v-icon> + membre Hors groupe
      </v-btn>
    </template>

    <v-dialog
      v-model="groupeDialog"
      transition="slide-x-transition"
      max-width="400"
    >
      <v-card>
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click="resetNewUserForm()">
              <v-icon>mdi-arrow-left</v-icon> </v-btn
            >Nouveau Membre {{ projet }}
          </v-toolbar-title>
        </v-app-bar>
        <v-card-text class="pb-0">
          <v-form ref="form_new_user" lazy-validation>
            <v-container fluid>
              <v-row no-gutters="">
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="nom_groupe"
                    label="Nom"
                    prepend-icon="person"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" lg="6">
                  <v-text-field
                    dense
                    v-model="annee_naissance"
                    label="Année de naissance"
                    prepend-icon="person"
                    type="number"
                    placeholder="1970"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-radio-group v-model="sexe" row>
                    <v-radio label="Masculin" value="1"></v-radio>
                    <v-radio label="Féminin" value="0"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                
                  <v-select
                    v-model="role_selected"
                    :items="RolesHorsGroupe"
                    chips
                    label="Rôle"
                    solo
                    item-text="ll_role_hors_groupe"
                
                    return-object
                    :rules="selectRules"
                  ></v-select>
                </v-col>

                <v-col cols="12" hidden>
                  <v-select
                    v-model="projets_selected"
                    :items="user.projets"
                    chips
                    label="Projets"
                    multiple
                    solo
                    item-text="ll_programme"
                    item-value="ll_programme"
                    @change="logProjectSelected()"
                    :rules="selectRules"
                  ></v-select>
                </v-col>

                <v-col cols="12">
                  <v-select
                    hint="Districts"
                    dense
                    @change="setCommunes()"
                    :rules="selectRules"
                    :items="districts"
                    label="Districts"
                    item-value="id"
                    item-text="ll_district"
                    solo
                    v-model="district_selected"
                    required
                    ref="district_selected"
                    :loading="communeLoading"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    hint="Communes"
                    dense
                    @change="setFokontanys()"
                    :rules="selectRules"
                    :items="communes"
                    label="Communes"
                    item-value="id"
                    item-text="ll_commune"
                    solo
                    required
                    v-model="commune_selected"
                    ref="commune_selected"
                    :loading="fokontanyLoading"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    hint="Fokontany"
                    dense
                    :items="fokontanys"
                    :rules="selectRules"
                    label="Fokontany"
                    item-value="id"
                    item-text="ll_fokontany"
                    solo
                    required
                    v-model="fokontany_selected"
                    ref="fokontany_selected"
                  >
                  </v-select>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="village"
                    label="Village"
                    prepend-icon="mdi-map"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-4">
          <v-btn
            class="rounded-pill neumorphic warning"
            @click="resetNewUserForm"
            >Annuler</v-btn
          >
          <v-btn
            class="rounded-pill neumorphic primary"
            :loading="newUserLoading"
            @click="createMembre"
            >Créer le Nouveau Membre</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editGroupeDialogue"
      transition="slide-x-transition"
      width="500"
    >
      <v-card flat>
        <v-card-title>Edition</v-card-title>
        <v-card-text>
          <v-form ref="form_edit_user_hors_groupe">
            <v-container fluid>
              <v-row no-gutters="">
                <v-col cols="12">
                  <v-text-field
                    dense
                    v-model="editedItem.nom_groupe"
                    label="Nom"
                    prepend-icon="person"
                    :rules="requis"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" lg="6">
                  <v-menu
                    v-model="menu3"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="
                          $moment(editedItem.annee_naissance).format(
                            'DD-MM-YYYY'
                          )
                        "
                        label="Année de naissance"
                        prepend-icon="mdi-calendar-cursor"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="fr"
                      v-model="editedItem.annee_naissance"
                      no-title
                      @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-radio-group v-model="editedItem.sexe" row>
                    <v-radio label="Masculin" value="1"></v-radio>
                    <v-radio label="Féminin" value="0"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="rounded-pill neumorphic warning"
            @click="editGroupeDialogue = false"
            >Annuler</v-btn
          >
          <v-btn
            class="rounded-pill neumorphic primary"
            :loading="newUserLoading"
            @click="updateMembre()"
            >Mettre à jour</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card flat>
      <v-autocomplete
        v-model="commune_selected2"
        :items="getCommunnesFromMembres()"
        menu-props="auto"
        label="Selectionnez une commune"
        hide-details
        prepend-icon="mdi-map"
        single-line
        @change="setMyHorsGroupeDeCommune()"
      ></v-autocomplete>
      <v-data-table
        :headers="headers"
        :items="setMyHorsGroupeDeCommune()"
        sort-by="nom"
        class="elevation-0"
      >
        <template v-slot:item.age="{ item }">
          <div>{{ calculate_age(item.annee_naissance) }} ans</div>
        </template>
        <template v-slot:item.sex="{ item }">
          <div>{{ getSexe(item.sexe) }}</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    console.log("animateur", this.animateur);
    if (this.animateur) {
      this.GetUserdetails(this.animateur);
      this.getMyHorsGroupe(this.animateur);
    } else {
      this.GetUserdetails(this.user.uid);
      this.getMyHorsGroupe(this.user.uid);
    }
  },
  props: {
    projet: {
      type: String,
      required: true,
    },
    animateur: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      sexe: "0",
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      userDetails: [],
      projets_selected: [this.projet],
      projectFiltered: [],
      menu2: false,
      menu3: false,
      groupeDialog: false,
      editGroupeDialogue: false,
      newFokontanyloader: false,
      districtLoading: false,
      communeLoading: false,
      fokontanyLoading: false,
      newUserLoading: false,
      valid: true,
      email: "",
      provinces: [],
      regions: [],
      communes: [],
      fokontanys: [],
      village: "",
      president: "",
      date_constitution: this.$moment().toISOString(),
      new_fokontany: "",
      Fokontanydata: "",
      showRegions: true,
      showDistricts: true,
      showCommunes: false,
      showFokontanys: false,
      showNewFokontany: false,
      province_selected: "",
      region_selected: "",
      district_selected: "",
      commune_selected: "",
      commune_selected2: "",
      fokontany_selected: "",
      role_selected: "",
      nom_groupe: "",
      annee_naissance: "",
      email: "",
      password: "",
      roles: [],
      show1: false,
      dialog: false,
      editedIndex: -1,
      editedItem: {
        sexe: "",
        annee_naissance: "",
        nom: "",
        nom_groupe: "",
      },
      headers: [
        { text: "nom", value: "nom" },
        { text: "sexe", value: "sex" },
        { text: "Age", value: "age" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },

  computed: {
    computedDateFormattedMomentjs() {
      return this.date_constitution
        ? this.$moment(this.date_constitution).format("DD-MM-YYYY")
        : "";
    },
    ...mapState({
      RolesHorsGroupe: (state) => state.RolesHorsGroupe.RolesHorsGroupe,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isGroupe: (state) => state.Auth.isGroupe,
      districts: (state) => state.Auth.user.districts,
      user: (state) => state.Auth.user,
      MyHorsGroupe: (state) => state.HorsGroupe.horsGroupe,
    }),
  },

  methods: {
    setMyHorsGroupeDeCommune() {
      console.log(this.commune_selected2);
      const communes_filtered = _.filter(this.MyHorsGroupe, {
        ll_commune: this.commune_selected2,
      });
      return communes_filtered;
    },
    getCommunnesFromMembres() {
      const communes = [];

      _.forEach(this.MyHorsGroupe, function (value) {
        communes.push(value.ll_commune);
      });
      return _.uniq(communes);
    },
    editItem(item) {
      this.editedIndex = this.MyHorsGroupe.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editGroupeDialogue = true;
    },
    deleteItem(item) {
      this.$confirm(
        "Voulez vous vraiment supprimer ce membre hors groupe?"
      ).then((res) => {
        if (res) {
          console.log(item);
        }
      });
    },
    updateMembre() {
      const item = this.editedItem;
      const self = this;
      item.annee_naissance = this.$moment(item.annee_naissance).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      item.nom = item.nom_groupe;
      const id = item.id;
      const idMembre = item.idMembre;
      const idGroupe = item.id_groupe;

      //update dans Membres Hors groupes
      var hgRef = this.$firebase
        .firestore()
        .collection("membresHorsGroupe")
        .doc(id);
      return hgRef
        .update({
          sexe: item.sexe,
          annee_naissance: item.annee_naissance,
          nom: item.nom,
          nom_groupe: item.nom,
        })
        .then(function () {
          console.log("vita");
          self.editGroupeDialogue = false;
          if (self.animateur) {
            self.GetUserdetails(this.animateur);
            self.getMyHorsGroupe(this.animateur);
          } else {
            self.GetUserdetails(this.user.uid);
            self.getMyHorsGroupe(this.user.uid);
          }
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
          self.editGroupeDialogue = false;
          if (self.animateur) {
            self.GetUserdetails(this.animateur);
            self.getMyHorsGroupe(this.animateur);
          } else {
            self.GetUserdetails(this.user.uid);
            self.getMyHorsGroupe(this.user.uid);
          }
        });
      //update dans Groupe
      var groupeRef = this.$firebase
        .firestore()
        .collection("groupes")
        .doc(idGroupe);
      return groupeRef
        .update({
          sexe: item.sexe,
          date_constitution: item.annee_naissance + "-01-01 00:00:00",
          nom_groupe: item.nom,
        })
        .then(function () {
          console.log("vita");
          self.editGroupeDialogue = false;
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
          self.editGroupeDialogue = false;
        });
      //update dans membres
      var membresRef = this.$firebase
        .firestore()
        .collection("membres")
        .doc(idMembre);
      return membresRef
        .update({
          sexe: item.sexe,
          annee_naissance: item.annee_naissance,
          nom: item.nom,
          nom_groupe: item.nom,
        })
        .then(function () {
          console.log("vita");
          self.editGroupeDialogue = false;
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
          self.editGroupeDialogue = false;
        });
    },

    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    calculate_age(dob) {
      // return(dob);
      var a = this.$moment();
      var b = this.$moment(dob, "YYYY-MM-DD HH:mm:ss");
      var diff = a.diff(b, "years"); // calculates patient's age in years
      return diff;
    },
    logProjectSelected() {
      let self = this;
      const filtered = _.filter(this.user.projets, function (projet) {
        return _.includes(self.projets_selected, projet.ll_programme);
      });
      this.projectFiltered = filtered;
    },

    ...mapActions({
      getMyHorsGroupe: "HorsGroupe/GetAll",
    }),
    GetUserdetails(idUser) {
      let self = this;
      var userRef = this.$firebase.firestore().collection("users").doc(idUser);
      userRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.userDetails.push({
              ...doc.data(),
              id: doc.id,
            });

            let userUid = self.userDetails[0].uid.toString();
            //let districtsDuSuperviseur = self.userDetails[0].districts;
          } else {
            // doc.data() will be undefined in this case
            console.log("Pas de résultats");
          }
        })
        .catch(function (error) {
          console.log("Error ici getting document:", error);
        });
    },

    setRegions() {
      var array = this.$regions;
      var regionsFiltrees = array.filter(
        (region) => region.province_id_province === this.province_selected
      );
      this.showRegions = true;
      this.regions = regionsFiltrees;
      this.districts = [];
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showNewFokontany = false;

      this.showDistricts = false;
      this.showCommunes = false;
      this.showFokontanys = false;
    },

    setCommunes() {
      this.logProjectSelected();
      var self = this;
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showCommunes = true;
      this.showFokontanys = false;
      this.showNewFokontany = false;
      this.communeLoading = true;

      this.$firebase
        .firestore()
        .collection("communes")
        .where("id_district", "in", [
          this.district_selected.toString(),
          this.district_selected,
        ])
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var commune = doc.data();
            commune.id = doc.id;
            self.communes.push({
              ...commune,
            });
            self.communeLoading = false;
          });
        });
    },

    setFokontanys() {
      var self = this;
      this.fokontanys = [];
      this.showFokontanys = true;
      this.new_fokontany = "";
      this.fokontanyLoading = true;
      var query = this.$firebase
        .firestore()
        .collection("fokontanys")
        .where("id_commune", "in", [
          this.commune_selected.toString(),
          this.commune_selected,
        ]);

      query.get().then(function (snap) {
        if (snap.empty) {
          //console.log("no documents found");
          self.showNewFokontany = true;
          self.showFokontanys = false;
          self.fokontanyLoading = false;
        } else {
          self.showNewFokontany = true;
          self.showFokontanys = true;
          self.fokontanys = [];
          self.fokontanyLoading = false;

          snap.forEach((doc) => {
            var fokontany = doc.data();
            //console.log(fokontany);
            fokontany.id = doc.id;
            self.fokontanys.push({
              ...fokontany,
            });
          });
        }
      });
    },

    resetNewUserForm() {
      this.$refs.form_new_user.reset();
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showCommunes = false;
      this.showFokontanys = false;
      this.showNewFokontany = false;
      this.communeLoading = false;
      this.districtLoading = false;
      this.groupeDialog = false;
      this.newUserLoading = false;
      this.editGroupeDialogue = false;
    },

    createMembre() {
      if (this.$refs.form_new_user.validate()) {
        var self = this;
        this.newUserLoading = true;

        let newGroupe = {
          pin1: "1234",
          pin3: "1234",
          pin2: "1234",
          date_insert_gp: this.$moment(new Date()).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          date_constitution: this.$moment(this.annee_naissance).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          id_region: this.$refs.district_selected.selectedItems[0].id_region,
          id_district: this.district_selected,
          ll_district: this.$refs.district_selected.selectedItems[0]
            .ll_district,
          nom_responsable: this.userDetails[0].displayName,
          latitude: "",
          longitude: "",
          id_commune: this.commune_selected,
          ll_fokontany: this.$refs.fokontany_selected.selectedItems[0]
            .ll_fokontany,
          newGroup: "1",
          active: "0",
          code_fokontany: this.fokontany_selected,
          ll_region: this.$refs.district_selected.selectedItems[0].ll_region,
          responsable: this.userDetails[0].id,
          president: this.president,
          ll_commune: this.$refs.commune_selected.selectedItems[0].ll_commune,
          password: "Osdrm123456",
          roles: {
            groupe: true,
          },
          id_province: this.$refs.district_selected.selectedItems[0]
            .province_id_province,
          ll_province: this.$refs.district_selected.selectedItems[0]
            .ll_province,
          nom_groupe: this.nom_groupe,
          email: this.nom_groupe + "_" + this.village + "@osdrmdatabase.online",
          village: this.village,
          projets: this.projectFiltered,
          hors_groupe: "1",
        };

        let uuidGroupe = "00000000000000aaaahrg-" + this.$uuid.v4();

        // Membres
        let uuidMembre = "00000000000000aaaaaaaaa-" + this.$uuid.v4();
        let uuidMembreHorsGroupe = "00000000000000aaaahrg-" + this.$uuid.v4();
        let newMembre = {
          id_groupe: uuidGroupe,
          actif_dans_groupe: 1,
          village: this.village,
          raison_inactivite: "",
          date_insert_membre: this.$moment(this.date_constitution).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          id_responsable: this.userDetails[0].id,
          code_menage: "-----------",
          nom_groupe: this.nom_groupe,
          annee_naissance: this.annee_naissance,
          sexe: this.sexe,
          membre_gec: "0",
          nom_responsable: this.userDetails[0].displayName,
          nom: this.nom_groupe,
          hors_groupe: "1",
          code_fokontany: this.fokontany_selected,
          ll_region: this.$refs.district_selected.selectedItems[0].ll_region,
          id_region: this.$refs.district_selected.selectedItems[0].id_region,
          id_district: this.district_selected,
          ll_commune: this.$refs.commune_selected.selectedItems[0].ll_commune,
          ll_fokontany: this.$refs.fokontany_selected.selectedItems[0]
            .ll_fokontany,
          id_province: this.$refs.district_selected.selectedItems[0]
            .province_id_province,
          ll_province: this.$refs.district_selected.selectedItems[0]
            .ll_province,
          ll_district: this.$refs.district_selected.selectedItems[0]
            .ll_district,
          id_commune: this.commune_selected,
          idMembre: uuidMembre,
          ll_role_hors_groupe: self.role_selected.ll_role_hors_groupe,
          id_role_hors_groupe: self.role_selected.id,
          id:uuidMembreHorsGroupe
        };

        //console.log("role_selected",self.role_selected)
        //CreateMembre

       /*  this.$firebase
          .firestore()
          .collection("membres")
          .doc(uuidMembre)
          .set(newMembre, { merge: true });
 */
        //CreateMembreHorsGroupe
      
        this.$firebase
          .firestore()
          .collection("membresHorsGroupe")
          .doc(uuidMembreHorsGroupe)
          .set(newMembre, { merge: true });

        //vuex insert new hors groupe
        
        this.newUserLoading = false;
        this.groupeDialog = false;
        this.resetNewUserForm();
        if (self.animateur) {
          self.GetUserdetails(this.animateur);
          self.getMyHorsGroupe(this.animateur);
        } else {
          self.GetUserdetails(this.user.uid);
          self.getMyHorsGroupe(this.user.uid);
        } 
        //console.log("creer membre hors Groupe");
      } else {
        console.clear();
        console.log("Valider d'abord");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-table {
  display: grid;
  grid-template-columns: repeat(auto-fill, 25%);
  padding: 10px;
  border-bottom: 1px #ccc solid;
}
</style>
